import { Component, computed, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SiteService } from '../../../services/api/site/site.service';

// Established year is a fixed fact of the site, not a data point.
const ESTABLISHED_YEAR = 2001;

const compact = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 });

@Component({
  selector: 'cf-site-footer',
  templateUrl: './site-footer.html',
  styleUrl: './site-footer.scss',
  providers: [SiteService]
})
export class SiteFooter {
  private readonly stats = toSignal(inject(SiteService).getSiteStats());

  readonly links = ['Rules', 'Discord', 'Contact'];

  tagline = computed(() => {
    const stats = this.stats();
    const parts = [`Est. ${ESTABLISHED_YEAR}`];
    if (stats) {
      parts.push(`${stats.memberCount.toLocaleString('en')} members`);
      parts.push(`${compact.format(stats.postCount)} posts`);
    }
    return parts.join(' · ');
  });
}
